import { useTranslation } from "react-i18next";
import { SwiperSlide } from "swiper/react";
import { useGetProductList } from "../api/queries/productQueries";
import ProdCard from "./box/ProdCard";
import ExploreOtherOptionsSwiper from "./explore-other-options-swiper/ExploreOtherOptionsSwiper";
import { UiTitle } from "./text/UiTitle";

const ExploreOtherOptions = ({
  productType,
  id,
}: {
  productType: string;
  id: number;
}) => {
  const { t } = useTranslation();
  const { data: products } = useGetProductList({
    type: productType,
    excludeIds: id + "",
  });

  return (
    <div className="explore-other-options border-t border-[#EAEEF3] pt-10">
      <UiTitle text={t("Explore other options")} />
      <ExploreOtherOptionsSwiper>
        {products?.map((product, index) => (
          <SwiperSlide className="white-shaddow-15 !h-auto" key={index}>
            <ProdCard contentOnly={true} {...product} />
          </SwiperSlide>
        ))}
      </ExploreOtherOptionsSwiper>
    </div>
  );
};

export default ExploreOtherOptions;
